<mat-card *ngIf="showWidget" class="mat-elevation-z0" (click)="doCommand()">
    <mat-card-content 
        fxLayout="column" 
        [matTooltip]="'Porta:' + doorIcon.statusLabel + ' | Serratura: ' + doorIcon.secondLabel"
        matTooltipPosition="below"
        [ngClass]="{ 'mat-elevation-z5': hasCommands() }" (click)="doCommand()"
    >
        <div class="office-door-widget" >
            <mat-icon [svgIcon]="doorIcon.code" class="door-icon" [ngClass]="doorIcon.colorClass"></mat-icon>
        </div>
    </mat-card-content>
</mat-card>